import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { withRouter } from 'react-router-dom';
const ScrollToTop = ({ children, location }) => {
    const previousLocation = React.useRef(location);
    React.useEffect(() => {
        var _a;
        // When a route is changed, the loaded page
        // should be displayed at the top of the screen.
        // Normally `window.scrollTo` would be used but only
        // the main body(#root) of the app is scrollable because
        // we prevent overscroll/bounce in iOS Safari:
        // https://www.bram.us/2016/05/02/prevent-overscroll-bounce-in-ios-mobilesafari-pure-css/
        if (location !== previousLocation.current) {
            (_a = document.getElementById('root')) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
        }
        previousLocation.current = location;
    }, [location]);
    return _jsx(_Fragment, { children: children });
};
const ScrollToTopWithRouter = withRouter(ScrollToTop);
const ScrollToTopOnRouteChange = InnerComponent => props => {
    return (_jsx(ScrollToTopWithRouter, { children: _jsx(InnerComponent, { ...props }) }));
};
export default ScrollToTopOnRouteChange;
